// translation.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageSelectorComponent } from '../components/language-selector.component';
import { TranslateDirective } from '../directives/translate.directive';
import { TranslatePipe } from '../pipes/translate.pipe';
import { TranslateComponent } from '../components/translation.component';

@NgModule({
    declarations: [
        TranslatePipe,
        TranslateDirective,
        LanguageSelectorComponent,
        TranslateComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        TranslatePipe,
        TranslateDirective,
        LanguageSelectorComponent,
        TranslateComponent
    ]
})
export class TranslationModule { }